import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ProtectedRoute } from '@/components/auth/ProtectedRoute';

function TimeTrackerContent() {
  const navigate = useNavigate();

  useEffect(() => {
    // Redirect to calendar as the default time tracker view
    navigate('/time-tracker/calendar', { replace: true });
  }, [navigate]);

  return null; // No need to render anything since we're redirecting
}

export default function TimeTrackerPage() {
  return (
    <ProtectedRoute>
      <TimeTrackerContent />
    </ProtectedRoute>
  );
}
